<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-instituciones"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { mapGetters } from 'vuex';
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, cellRendererSiONo, formatearNumeroAMoneda } from '../../utils/funciones';

export default {
  name: 'ListadoInscripcionesCompletas',
  mixins: [listadoAgGridMixin],
  mounted() {
    this.toggleColumnVisibility('headerName', 'PAGOS', this.getMostradoPagos);
  },
  watch: {
    getMostradoPagos(value) {
      this.toggleColumnVisibility('headerName', 'PAGOS', value);
    },
  },
  computed: {
    ...mapGetters({
      getMostradoPagos: 'comision/getMostradoPagos',
    }),
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ID. INSCRIPCIÓN',
          field: 'id',
          filter: true,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'FECHA INSCRIPCIÓN',
          field: 'fechaRegistroInscripcion',
          filter: true,
          cellRenderer: (params) => {
            const fechaRegistroInscripcion = params.data.fechaRegistroInscripcion;

            if (!fechaRegistroInscripcion) {
              return '-';
            }

            const fecha = new Date(fechaRegistroInscripcion);
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();

            return `${dia}/${mes}/${anio}`;
          },
          valueGetter: (params) => {
            const fechaRegistroInscripcion = params.data.fechaRegistroInscripcion;

            if (!fechaRegistroInscripcion) {
              return '-';
            }

            const fecha = new Date(fechaRegistroInscripcion);
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();

            return `${dia}/${mes}/${anio}`;
          },
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'SEDE',
          field: 'nombreSede',
          filter: true,
          minWidth: 200,
        },
        {
          headerName: 'UNIVERSIDAD',
          field: 'nombreUniversidad',
          filter: true,
          minWidth: 300,
        },
        {
          headerName: 'CUMPL. REQUISITOS',
          cellRenderer: cellRendererSiONo('cumplimientoRequisitos', 'SI', 'NO'),
          filter: true,
          valueGetter: (params) => {
            return params.data.cumplimientoRequisitos ? 'SI' : 'NO';
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'ESTADO INSCRIPCIÓN',
          field: 'estadoInscripcion',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
          cellRenderer: (params) => {
            return params.data.estadoInscripcion.toUpperCase();
          },
        },
        {
          headerName: 'PLAN COBRO PROGRAMA',
          field: 'planCobroPrograma',
          filter: true,
          minWidth: 250,
        },
        {
          headerName: 'ID. PROGRAMA',
          field: 'programaId',
          filter: true,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'COD. PROGRAMA',
          field: 'codigoPrograma',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'PROGRAMA',
          field: 'nombrePrograma',
          filter: true,
          minWidth: 500,
        },
        {
          headerName: 'TIPO',
          field: 'nombreCategoria',
          filter: true,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ÁREA',
          field: 'nombreArea',
          filter: true,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'NUM. DOC. ESTUDIANTE',
          field: 'numeroDocumentoEstudiante',
          filter: true,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'NOMBRE COMPLETO ESTUDIANTE',
          field: 'nombreCompletoEstudiante',
          filter: true,
          minWidth: 300,
        },
        {
          headerName: 'CUOTAS COL.',
          field: 'cuotas',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
          type: 'numericColumn',
        },
        {
          headerName: 'MONTO COL.',
          field: 'monto',
          filter: false,
          minWidth: 120,
          maxWidth: 120,
          type: 'numericColumn',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            return formatearNumeroAMoneda(params.data.monto);
          },
        },
        {
          headerName: 'UNIDAD DE NEGOCIO',
          field: 'nombreUnidadNegocio',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'NUM. DOC. ASESOR',
          field: 'numeroDocumentoAsesor',
          filter: true,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'NOMBRE COMPLETO ASESOR',
          field: 'nombreCompletoAsesor',
          filter: true,
          minWidth: 300,
        },
        {
          headerName: 'PAGOS',
          field: 'pagos',
          filter: false,
          minWidth: 1500,
          maxWidth: 1500,
          autoHeight: true,
          headerComponentParams: {
            template: /* html */ `
              <table width="100%" style="border-collapse">
                <tr>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 70px;">#</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 130px;">CONCEPTO</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 150px;">FECHA EMISIÓN</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 150px;">FECHA PAGO</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">N° RECIBO</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">IMPORTE</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">MONTO</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">N° CUOTA</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">DESCUENTO</th>
                  <th style="font-size: 13px; font-weight: 600; text-align: center; width: 120px;">SALDO</th>
                </tr>
              </table>
            `,
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            if (!params.data.pagos || params.data.pagos.length === 0) {
              return '';
            }

            let tabla = /*html*/ `<table width="100%" style="border-collapse">`;

            params.data.pagos.forEach((pago, index) => {
              tabla += /*html*/ `
                <tr ${pago.saldo > 0 ? 'style="background-color: #ffcccc"' : ''}>
                  <td style="font-size: 13px; width: 70px;">${index + 1}</td>
                  <td style="font-size: 13px; width: 130px;">${pago.concepto}</td>
                  <td style="font-size: 13px; width: 150px;">${pago.fechaEmision}</td>
                  <td style="font-size: 13px; width: 150px;">${pago.fechaPago}</td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">${pago.numeroRecibo}</td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">
                    ${formatearNumeroAMoneda(pago.importe)}
                  </td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">
                    ${formatearNumeroAMoneda(pago.monto)}
                  </td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">${pago.numeroCuota}</td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">
                    ${formatearNumeroAMoneda(pago.descuento)}
                  </td>
                  <td style="font-size: 13px; width: 120px; text-align: right;">
                    ${formatearNumeroAMoneda(pago.saldo)}
                  </td>
                </tr>
              `;
            });

            tabla += /*html*/ `</table>`;

            return tabla;
          },
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-instituciones {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}
</style>
  